// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bc47acad","455":"5dcee386","977":"fe041a77"}[chunkId] + ".chunk.js";
};